import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { renderTemplate } from '../../utils/templateRenderer';

const CertificatePreview = ({ template, data }) => {
  const renderedHTML = renderTemplate(template.body, data);

  return (
    <div className="w-full overflow-x-auto">
      <div className="flex flex-col items-end">
        {/* Photo section - aligned to the right above the title */}
        {data.photo_url && (
          <div className="mb-4">
            <div className="w-32 h-40 border-2 border-gray-300 overflow-hidden bg-gray-50">
              <img
                src={data.photo_url}
                alt="Resident Photo"
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div
                className="w-full h-full items-center justify-center text-gray-400 text-xs text-center p-2"
                style={{ display: 'none' }}
              >
                No Photo
              </div>
            </div>
          </div>
        )}

        {/* Main certificate content */}
        <div className="w-full">
          <ReactQuill
            value={renderedHTML}
            readOnly={true}
            modules={{ toolbar: false }}
            theme="snow"
            className="bg-white rounded"
            style={{ width: '100%', maxWidth: '100%' }}
          />
        </div>
      </div>

      <style>{`
        .ql-container { 
          border: none !important; 
          max-width: 100% !important;
          overflow-x: auto !important;
        }
        .ql-editor {
          max-width: 100% !important;
          overflow-x: auto !important;
          word-wrap: break-word !important;
          overflow-wrap: break-word !important;
        }
      `}</style>
    </div>
  );
};

export default React.memo(CertificatePreview);